module.exports = __webpack_public_path__ + "images/5cdb6c94fa927b9022ecbb5070d5e2760dd62f2bb9d339e184cb5c454104291a.svg";